"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./IconItem.scss");

require("./IconItemDark.scss");

var _classNames = _interopRequireDefault(require("../../util/classNames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconItem = function IconItem(props) {
  var classes = (0, _classNames["default"])({
    disabled: props.disabled,
    active: props.disabled ? false : props.active
  });

  var onClick = function onClick() {
    !props.disabled && props.onClick();
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-icon-item ' + classes,
    tabindex: 'user' + props.id,
    onClick: onClick
  }, props.icon && /*#__PURE__*/_react["default"].createElement("i", {
    className: 'gcl-icon ' + props.icon + ' ' + props.size
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-icon-item-text'
  }, props.children));
};

IconItem.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  active: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].isRequired,
  icon: _propTypes["default"].string.isRequired,
  size: _propTypes["default"].oneOf(['small', 'large', ''])
};
IconItem.defaultProps = {
  onClick: function onClick() {
    return console.warn('no function was assigned as prop');
  },
  active: false,
  disabled: false,
  icon: '',
  iconSize: ''
};
var _default = IconItem;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/IconItem/IconItem.js
// module id = 694
// module chunks = 0